import useTableQuery from '@/hooks/useTableQuery';
import { getAssistantList } from '@/services/AssistantManagement';

export default function () {
  const {
    setQueryData,
    resetPage,
    pageChange,
    Loading,
    result,
    total,
    current,
    size,
    handles,
  } = useTableQuery(getAssistantList, {
    serchData: { keywords: '', state: 0 },
    debounceInterval: 0
  });

  return {
    setQueryData,
    resetPage,
    pageChange,
    Loading,
    result,
    total,
    current,
    size,
    handles,
  };
}
